var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('sarala-table',{ref:"table",attrs:{"model":_vm.model,"createRoute":{
                name: 'activation.create',
                params: {
                    category_id: _vm.categoryId,
                },
            },"resourceName":_vm.$tc('resources.activation.name', 1),"query":_vm.categoryFilter},scopedSlots:_vm._u([{key:"value",fn:function(ref){
            var item = ref.item;
return [_vm._v("\n                "+_vm._s(_vm.$n(item.value, 'currency'))+"\n            ")]}},{key:"amount",fn:function(ref){
            var item = ref.item;
return [_vm._v("\n                "+_vm._s(item.amount ? item.amount : '-')+"\n            ")]}},{key:"action",fn:function(ref){
            var item = ref.item;
return [_c('edit-btn',{attrs:{"to":{
                        name: 'activation.edit',
                        params: { id: item.id, category_id: _vm.categoryId },
                    }}}),_c('delete-btn',{on:{"click":function($event){return _vm.deleteItem(item)}}})]}}])})],1),_c('confirm-delete',{ref:"confirmDelete"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }